<template lang="pug">
div
  div.text-center(v-if='group && group.autoInscription.method != "public" && (group.userInscriptionStatus == "" && statusPrivateKey == null)')
    | {{$t('globals.loading')}}
  div.text-center(v-else-if='(group && group.autoInscription.method == "public") || (group && group.autoInscription.method == "private" && group.userInscriptionStatus != "") || hasCorrectPrivateKey')
    .alert.alert-success(v-if='group.userInscriptionStatus == "LOADING"') {{$t('globals.sending')}}
    .alert.alert-success(v-else-if='group.userInscriptionStatus == "MEMBER"') {{$t('groupPages.modules.autoInscription.youAreMember')}}
    .alert.alert-warning(v-else-if='group.userInscriptionStatus == "PENDING_INVITATION"') {{$t('groupPages.modules.autoInscription.waitConfirmation')}}
    template(v-else)
      .alert
        a.btn.btn-success(@click='goToAutoInscription') {{$t('groupPages.modules.autoInscription.joinThisGroup')}}
    p 
      i.fa.fa-info-circle
      |  {{$t('groupPages.modules.autoInscription.explanation')}}
    p(v-if="canEdit")
      a(role="button", @click="goToManagement") {{$t('groups.createMembersModal.changeAutoInscription')}}
  div(v-else)
    .alert.alert-danger
      | {{$t('groupPages.modules.autoInscription.error')}}

</template>

<script>
import {mapGetters} from 'vuex'
import api from '@/utils/api'

import modalsBus from '@/components/shared/ModalsBus'
const statusOK = 'OK'
const statusKO = 'KO'
export default {
  props: ['vueData', 'module', 'openEditor', 'canEdit'],
  data () {
    return {
      statusPrivateKey: null
    }
  },
  mounted () {
    if (window.clickedAutoInscriptionBeforeConnection === true && this.isConnected) {
      this.$nextTick(() => {
        this.goToAutoInscription()
      })
    }
    window.clickedAutoInscriptionBeforeConnection = false
    this.checkPrivateKey()
    this.$appwireEvents.$on('invitations', this.threatInvitations)
  },
  destroyed () {
    this.$appwireEvents.$off('invitations', this.threatInvitations)
  },
  computed: {
    ...mapGetters('user', [
      'isConnected',
      'user'
    ]),
    group () {
      return this.vueData.data.group
    },
    hasCorrectPrivateKey () {
      return this.statusPrivateKey === statusOK
    },
    hasIncorrectPrivateKey () {
      return this.statusPrivateKey === statusKO
    }
  },
  methods: {
    threatInvitations (data) {
      if (this.isConnected) {
        if (data.action === 'confirmed' &&
            data.gid === this.group.id &&
            data.uid === this.user.id) {
          this.$set(this.group, 'userInscriptionStatus', 'MEMBER')
        }
      }
    },
    goToManagement () {
      this.$router.push({name: 'GroupManagement', params: {groupId: this.group.id, anchor: 'autoInscription'}})
    },
    goToAutoInscription () {
      if (this.isConnected) {
        this.$set(this.group, 'userInscriptionStatus', 'LOADING')
        api.post(`group/${this.group.id}/meAsMember`, {key: this.$route.query.privateKey}).then((response) => {
          if (response.data.result === 'needConfirmation') {
            this.$set(this.group, 'userInscriptionStatus', 'PENDING_INVITATION')
          } else if (response.data.result === 'member') {
            this.$set(this.group, 'userInscriptionStatus', 'MEMBER')
            this.$store.dispatch('groops/reload', true)
          }
        })
      } else {
        window.clickedAutoInscriptionBeforeConnection = true
        modalsBus.open(modalsBus.modals.CONNECTION)
      }
    },
    checkPrivateKey () {
      if (!this.$route.query.privateKey) {
        this.statusPrivateKey = null
        return
      }
      api.get('checkGroupPrivateKey/' + this.group.id, {
        params: {
          privateKey: this.$route.query.privateKey
        },
        __noToken: true
      })
      .then(() => { this.statusPrivateKey = statusOK })
      .catch(() => { this.statusPrivateKey = statusKO })
    }
  },
  watch: {
    '$route': {
      deep: true,
      handler () {
        this.checkPrivateKey()
      }
    },
    group () {
      this.checkPrivateKey()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// GroupPageNewMember.vue?37015f3d